import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import { StaticImage } from "gatsby-plugin-image";

import Video1 from "../../images/services-usa/saas-video/portfolio-video/christian_connection.mp4";
import Video2 from "../../images/services-usa/saas-video/portfolio-video/gift-zombie.mp4";
import Video3 from "../../images/services-usa/saas-video/portfolio-video/purser.mp4";
import Video4 from "../../images/services-usa/saas-video/portfolio-video/sustained_business.mp4";
import Video5 from "../../images/services-usa/saas-video/portfolio-video/orca.mp4";
import Video6 from "../../images/services-usa/saas-video/portfolio-video/luckmon.mp4";

function Winningportfolio() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <section
      className="winning_portfolio p-100"
      style={{ background: "#FAFAFA" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Winning Portfolio: The Best <span>SaaS Explainer Videos</span>
            </h2>
            <p>
              When it comes to gaining traction with videos, our video team
              hones its chops. And we show it with our great work. Our portfolio
              features some of the best SaaS explainer videos ever created.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              spaceBetween={10}
              thumbs={{ swiper: thumbsSwiper }}
              modules={[FreeMode, Thumbs]}
              className="winning_video_slider"
            >
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video1} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video2} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video3} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video4} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video5} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_video">
                  <video muted loop autoPlay id="myVideo" playsInline>
                    <source src={Video6} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
            </Swiper>
            <Swiper
              onSwiper={setThumbsSwiper}
              spaceBetween={10}
              slidesPerView={6}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 4,
                },
                1600: {
                  slidesPerView: 6,
                },
              }}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Thumbs]}
              className="winning_image_slider"
            >
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/christian-connection.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/gift_zombie.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/purser.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/luckmon.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/orca.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="portfolio_image">
                  <StaticImage
                    src="../../images/services-usa/saas-video/portfolio/sustained_business.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={960}
                    height={540}
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Winningportfolio;
